import { ImageSize } from '@vpfa/utils';
import { ImagesState } from '../+state/images.reducer';

export function getImageFromState(state: ImagesState, imageUrl: string, imageSize: ImageSize) {
  return state?.[imageUrl]?.[imageSize];
}
